import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLiveTail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M14.887 4.05a.75.75 0 0 1 1.06 0A8.4 8.4 0 0 1 18.414 10c0 2.319-.94 4.42-2.456 5.94a.75.75 0 0 1-1.062-1.059A6.9 6.9 0 0 0 16.913 10c0-1.91-.773-3.637-2.026-4.889a.75.75 0 0 1 0-1.06Zm-9.782.007a.75.75 0 0 1 .001 1.06A6.9 6.9 0 0 0 3.086 10a6.9 6.9 0 0 0 2.05 4.913.75.75 0 0 1-1.054 1.066A8.4 8.4 0 0 1 1.587 10c0-2.32.94-4.42 2.457-5.942a.75.75 0 0 1 1.06-.001Z" />
    <path d="M12.341 6.597a.75.75 0 0 1 1.061 0A4.8 4.8 0 0 1 14.812 10a4.8 4.8 0 0 1-1.405 3.398.75.75 0 0 1-1.062-1.06A3.3 3.3 0 0 0 13.312 10a3.3 3.3 0 0 0-.97-2.342.75.75 0 0 1 0-1.06ZM7.654 6.6a.75.75 0 0 1 .001 1.06A3.3 3.3 0 0 0 6.688 10a3.3 3.3 0 0 0 .982 2.354.75.75 0 1 1-1.055 1.066A4.8 4.8 0 0 1 5.188 10a4.8 4.8 0 0 1 1.405-3.399.75.75 0 0 1 1.06 0Zm3.266 4.317a1.295 1.295 0 0 0-.001-1.836A1.296 1.296 0 0 0 8.7 10a1.296 1.296 0 0 0 1.3 1.298c.36 0 .685-.146.92-.382Z" />
  </svg>
);
export default SvgLiveTail;
